module.exports = __webpack_public_path__ + "static/img/8.3b0260a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/8.png
// module id = V9Ei
// module chunks = 0